/**
 * This is a utility to handle default API requests with the Yote server
 */

import fetch from 'isomorphic-fetch';

const baseUrl = ""; //later required for server rendering

export default function callAPI(route, method = 'GET', body, headers = {
  'Accept': 'application/json', 'Content-Type': 'application/json'
}) {
  return fetch(baseUrl + route, {
    headers
    , method
    , credentials: 'same-origin'
    , body: JSON.stringify(body)
  })
    .then(response => {
      // console.log("CHECK RESPONSE CODE")
      // console.log(response.status)
      if (response && response.status && response.status == 401) {
        // console.log("REDIRECT ME")
        /**
         * thoughts here. we want a way to loudly fail when the user is auto-logged out
         * vs silently breaking
         * i think a hard (non-redux) redirect is the way to go, since it should 
         * refresh the user from the server and wipe anything currently in the store
         */
        // window.location.href = ""; // to root
        window.location.reload(); // preserve location on redirect

      }
      return response
    })
    .then(response => response.json())
}



// WEBPACK FOOTER //
// global/utils/api.js